<template>
  <v-container max-width="$vuetify.breakpoint.lg" class="page">
    <v-row class="ticket_cut_out">
      <v-col sm="3" class="qr-code">
        <div class="text-center">
          <h2>Order #{{ ticket.orderId }}</h2>
        </div>
        <div class="text-center">
          <qrcode-vue :value="ticket.barcode" size="200" level="H" />
        </div>

        <div class="text-center">{{ readableBarcode }}</div>
      </v-col>
      <v-col sm="9" class="pt-4 pr-4 ticket-info">
        <div class="float-right pr-2 pt-2">{{ index }} of {{ total }}</div>
        <div class="email-ticket mb-2 float-md-right pr-4">
          <v-btn @click="handleCopyClick" color="primary">
            <v-icon left>mdi-content-copy</v-icon>
            Copy Ticket Link
          </v-btn>
        </div>
        <h3 v-html="ticket.eventName"></h3>
        <p class="mb-0" v-if="ticket.eventName != 'Festival Guidebook'">
          {{ ticket.eventDate }}
        </p>
        <p class="py-2 mb-0">{{ ticket.ticketType }}</p>
        <v-row>
          <v-col>
            <v-list dense>
              <v-list-item
                class="list_item"
                dense
                v-if="ticket.eventName != 'Festival Guidebook'"
              >
                <v-list-item-icon class="my-0 align-self-center">
                  <v-icon>mdi-map-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    class="list_title"
                    v-text="ticket.venueName"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="list_item">
                <v-list-item-icon class="my-0 align-self-center">
                  <v-icon>mdi-email-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    class="list_title"
                    v-text="ticket.customerEmail"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="list_item" v-if="ticket.customerPhone">
                <v-list-item-icon class="my-0 align-self-center">
                  <v-icon>mdi-phone-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    class="list_title"
                    v-text="ticket.customerPhone"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="list_item">
                <v-list-item-icon class="my-0 align-self-center">
                  <v-icon>mdi-web</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    class="list_title"
                    v-text="ticket.customerWebsite"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col>
            <v-row justify="center" class="ma-4">
              <img
                v-if="ticket.eventTicketImage"
                class="print-view-image"
                :src="
                  `https://www.tempotickets.com/tempotickets/file_store/${ticket.eventTicketImage}`
                "
              />
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="d-flex flex-column bottom-row">
        <div
          style="width: 100%; display: flex; flex-direction: row; align-items: center;"
        >
          <div class="text-uppercase font-weight-bold" style="width: 370px;">
            This is your Ticket
          </div>
          <div class="text-center">
            <a
              href="https://www.tempotickets.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="@/assets/tempo-logo-new-blue.png"
                alt="Tempo Logo"
                style="width: 300px; height: auto; margin: 8px 0;"
                class="tempo-logo"
              />
            </a>
          </div>
          <div style="width: 479px; text-align: right;">
            ticketing by <span class="font-weight-bold"> Tempo </span> •
            <a
              href="https://www.tempotickets.com"
              target="_blank"
              rel="noopener noreferrer"
              >tempotickets.com</a
            >
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import QrcodeVue from "qrcode.vue";

export default {
  name: "printable-ticket",
  components: {
    QrcodeVue
  },
  props: ["ticket", "index", "total"],
  computed: {
    readableBarcode() {
      const code = this.ticket.barcode;
      if (code?.length < 6) {
        // usually bar codes are 8 digits but if that changes we don't want substring errors.
        return code;
      }
      return (
        code.substring(0, 3) +
        " " +
        code.substring(3, 6) +
        " " +
        code.substring(6)
      );
    },
    formatPhoneNumber() {
      const cleaned = ("" + this.ticket.customerPhone).replace(/\D/g, "");
      const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        var intlCode = match[1] ? "+1 " : "";
        return [intlCode, match[2], "-", match[3], "-", match[4]].join("");
      }
      return null;
    }
  },
  methods: {
    handleCopyClick() {
      console.log("Copy button clicked"); // Debug log
      this.copyTicketUrl();
    },
    getTicketUrl() {
      return `${window.location.origin}${this.$route.fullPath}/${this.ticket.barcode}`;
    },
    async copyTicketUrl() {
      const url = this.getTicketUrl();
      console.log("Attempting to copy URL:", url); // Debug log

      // Fallback for browsers without Clipboard API
      if (!navigator.clipboard) {
        this.$root.$emit("showSnackbar", {
          message: "❌ Clipboard API not supported",
          color: "error"
        });
        return;
      }

      try {
        await navigator.clipboard.writeText(url);
        console.log("URL copied successfully"); // Debug log
        this.$root.$emit("showSnackbar", {
          message: "✅ Ticket URL copied to clipboard!",
          color: "success"
        });
        console.log("Snackbar event emitted"); // Debug log
      } catch (error) {
        console.error("Copy failed:", error); // Debug log
        this.$root.$emit("showSnackbar", {
          message: "❌ Failed to copy URL to clipboard",
          color: "error"
        });
      }
    }
  }
};
</script>
<style scoped>
.ticket_cut_out a {
  color: #000000 !important;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.contact-icon {
  vertical-align: baseline;
  font-size: 16px;
}
.print-view-image {
  max-height: 200px;
  max-width: 100%;
}
.ticket_cut_out {
  border: 2px dashed;
  margin: 10px;
  background-color: white;
  padding: 20px 20px 0;
}

.bottom-row {
  margin-top: auto;
  padding-bottom: 10px;
}
.list_item {
  min-height: unset;
}
.parking-div {
  white-space: pre;
}
.venue-info {
  font-size: large;
}
.ticket-section-heading {
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 3px double;
  font-size: 12pt;
  font-weight: bold;
  padding-bottom: 5px;
  margin-bottom: 10px;
}

.tempo-logo {
}
@media print {
  .email-ticket {
    display: none;
  }
  .page {
    break-after: page;
  }
  .list_title {
    white-space: unset;
  }
  .qr-code {
    flex: unset;
    width: unset;
    max-width: 40%;
    z-index: 10000;
  }
  .ticket-info {
    max-width: 60%;
  }
}
</style>
